module.exports = __webpack_public_path__ + "img/Frente-56-00 off.3fc92d40.png";